/* tslint:disable */
/* eslint-disable */
export enum UpgradeStatus {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE',
  InProgress = 'IN_PROGRESS',
  Waitlisted = 'WAITLISTED',
  Success = 'SUCCESS',
  Failed = 'FAILED'
}
